module.exports = __webpack_public_path__ + "static/media/checkboxInstall3.4541dcad.svg";